import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, Inject } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { TicketType } from "../../model/domain/Entity";
import {
  ShareholderFundPositionFundInvoiceModel,
  ShareholderFundPositionModel,
} from "../../model/domain/ShareholderFundPositionModel";
import {
  StockFixedIncome,
  StockFixedIncomeCommittedPosition,
  StockFixedIncomePosition,
} from "../../model/domain/StockFixedIncomeModel";
import {
  StockFunds,
  StockFundsPosition,
} from "../../model/domain/StockFundsModel";
import {
  StockVariableIncome,
  StockVariableIncomePosition,
} from "../../model/domain/StockVariableIncomeModel";
import { StockService } from "../../services/stock.service";
import { ValidatorService } from "../../services/validator.service";

export interface StockDialogData {
  fundSourceId: string;
  ticketType: TicketType;
}

@Component({
  selector: "app-stock-funds",
  templateUrl: "./stock-funds.component.html",
  styleUrls: ["./stock-funds.component.scss"],
})
export class StockFundsComponent implements AfterViewInit {
  constructor(
    private stockService: StockService,
    private datePipe: DatePipe,
    public validator: ValidatorService,
    public dialogRef: MatDialogRef<StockFundsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StockDialogData
  ) {}

  faCircleCheck = faCircleCheck;

  stockDataFunds: StockFunds = new StockFunds();
  stockDataFixedIncome: StockFixedIncome = new StockFixedIncome();
  stockDataVariableIncome: StockVariableIncome = new StockVariableIncome();
  stockDataShareholdersFunds: ShareholderFundPositionModel =
    new ShareholderFundPositionModel();

  columnsFund: string[] = [
    "select",
    "fundSourceId",
    "fundName",
    "institutionName",
    "availableQuantity",
    "quotaValue",
    "netValue",
  ];

  columnsFixedIncome: string[] = [
    "select",
    "code",
    "selicCode",
    "operationCode",
    "purchaseDate",
    "issueCode",
    "issuerName",
    "serie",
    "issueDate",
    "dueDate",
    "quantity",
    "pu",
    "purchaseValue",
    "netValue",
  ];

  columnsFixedIncomeCommitted: string[] = [
    "select",
    "operationCode",
    "purchaseDate",
    "securityName",
    "originalDate",
    "dueDate",
    "issuerName",
    "quantity",
    "pu",
    "purchaseValue",
  ];

  columnsVariableIncome: string[] = [
    "select",
    "assetCode",
    "assetName",
    "availableAmount",
    "blockedAmount",
    "totalAmount",
    "price",
    "totalCost",
    "result",
    "netValue",
  ];

  columnsShareholderFund: string[] = [
    "select",
    "invoiceId",
    // "settlementStockDetainer",
    "applicationDate",
    // "settlementDate",
    "quotaAmount",
    "applicationValue",
    // "correctedValue",
    // "iofValue",
    // "iofAliquot",
    // "iofElapsedDays",
    // "taxValue",
    // "taxAliquot",
    // "taxElapsedDays",
    "redemptionValue",
    "incomeValue",
    // "resultPercentage",
    // "iofExemptionDate",
  ];

  ngOnInit() {}

  ngAfterViewInit() {
    this.modelInit();
  }

  modelInit() {
    if (this.isQuota()) {
      this.stockService
        .getFundStock(this.data.fundSourceId)
        .subscribe((res) => {
          this.stockDataFunds = res;
          this.stockDataFunds.positionDate = this.datePipe.transform(
            this.stockDataFunds.positionDate,
            "dd/MM/yyyy",
            "UTC"
          ) as any;
        });
    } else if (this.isFixedIncome()) {
      this.stockService
        .getFixedIncomeStock(this.data.fundSourceId)
        .subscribe((res) => {
          this.stockDataFixedIncome = res;
          this.stockDataFixedIncome.positionDate = this.datePipe.transform(
            this.stockDataFixedIncome.positionDate,
            "dd/MM/yyyy",
            "UTC"
          ) as any;
        });
    } else if (this.isVariableIncome()) {
      this.stockService
        .getVariableIncomeStock(this.data.fundSourceId)
        .subscribe((res) => {
          this.stockDataVariableIncome = res;
          this.stockDataVariableIncome.positionDate = this.datePipe.transform(
            this.stockDataVariableIncome.positionDate,
            "dd/MM/yyyy",
            "UTC"
          ) as any;
        });
    } else if (this.isContracted()) {
      this.stockService
        .getStockFixedIncomeCommitted(this.data.fundSourceId)
        .subscribe((res) => {
          this.stockDataFixedIncome = res;
          this.stockDataFixedIncome.positionDate = this.datePipe.transform(
            this.stockDataFixedIncome.positionDate,
            "dd/MM/yyyy",
            "UTC"
          ) as any;
        });
    } else if (this.isLiabilities()) {
      this.stockService
        .getShareholderFundStock(this.data.fundSourceId)
        .subscribe((res) => {
          this.stockDataShareholdersFunds = res;
          this.stockDataShareholdersFunds.positionDate =
            this.datePipe.transform(
              this.stockDataShareholdersFunds.positionDate,
              "dd/MM/yyyy",
              "UTC"
            ) as any;
        });
    }
  }

  isQuota(): boolean {
    return this.data.ticketType === TicketType.Quota;
  }

  isFixedIncome(): boolean {
    return (
      this.data.ticketType === TicketType.CETIP ||
      this.data.ticketType === TicketType.SELIC
    );
  }

  isContracted(): boolean {
    return this.data.ticketType === TicketType.Contracted;
  }

  isVariableIncome(): boolean {
    return this.data.ticketType === TicketType.VariableIncome;
  }

  isLiabilities(): boolean {
    return this.data.ticketType === TicketType.Liabilities;
  }

  selectFund(selected: StockFundsPosition) {
    this.dialogRef.close(selected);
  }

  selectFixedIncome(selected: StockFixedIncomePosition) {
    this.dialogRef.close(selected);
  }

  selectFixedIncomeComitted(selected: StockFixedIncomeCommittedPosition) {
    this.dialogRef.close(selected);
  }

  selectVariableIncome(selected: StockVariableIncomePosition) {
    this.dialogRef.close(selected);
  }

  selectShareholderFund(selected: ShareholderFundPositionFundInvoiceModel) {
    this.dialogRef.close(selected);
  }
}
